import { cn } from './cn'
export const dialogPanelOverlayClassName = 'fixed inset-0 z-50 bg-foreground/35 backdrop-blur-[2px]'
export function dialogSurfaceStyles(
  width: 'compact' | 'regular' | 'wide' = 'regular',
  placement: 'center' | 'start' = 'center',
) {
  return cn(
    'fixed z-50 flex flex-col overflow-hidden border border-border bg-card text-foreground shadow-overlay outline-none',
    placement === 'start'
      ? 'inset-y-0 left-0 h-dvh w-[min(88vw,320px)] rounded-r-panel'
      : 'top-1/2 left-1/2 max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-panel',
    placement === 'center' &&
      (width === 'compact'
        ? 'max-w-[440px]'
        : width === 'wide'
          ? 'max-w-[680px]'
          : 'max-w-[560px]'),
  )
}
